import * as React from 'react';

type Props = {
  children: React.ReactNode;
};

export const ClubProgrammePageBody: React.FC<Props> = ({ children }) => {
  return <div className="cpPageBody">{children}</div>;
};
